import { useEffect, useState } from "react";
import { getContactDetails, getSections, getStoreLocations } from "../lib/siteContent";

/** Editor-managed sections for one page, in the order the admin set. */
export function useSections(placement) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let active = true;
    getSections(placement).then((data) => { if (active) setRows(data); });
    return () => { active = false; };
  }, [placement]);
  return rows;
}

/** Address, phone, email, hours and socials as the admin panel has them. */
export function useContactDetails() {
  const [details, setDetails] = useState(null);
  useEffect(() => {
    let active = true;
    getContactDetails().then((data) => { if (active) setDetails(data); });
    return () => { active = false; };
  }, []);
  return details;
}

/** Visible boutiques in admin order; [] until loaded or when none published. */
export function useStoreLocations() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let active = true;
    getStoreLocations().then((data) => { if (active) setRows(data); });
    return () => { active = false; };
  }, []);
  return rows;
}
